import {Either} from 'shared/web';

type Quantity = {
  newQuantity: number;
};

type QuantityError = {
  hasError: boolean;
};

export type EitherQuantityOrError = Either<Quantity, QuantityError>;
